import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Floor = createSvgIcon(
  <path d="M2.25 0v5.16L6.5.908l4.875 4.875 5.5-5.5 6.841 6.841-5.25 5.25 4.5 4.5-4.875 4.875H24V24H0V0h2.25Zm18.284 7.125-3.659-3.659-8.159 8.159 3.659 3.659 8.159-8.159Zm-10.75.25L6.5 4.091l-4.25 4.25v6.568l7.534-7.534Zm1 9.5-3.659-3.659-4.875 4.875v3.659h3.659l4.875-4.875ZM9.091 21.75h5.818l4.875-4.875-2.909-2.91-7.784 7.785Z" />,
  'Floor'
);

export { Floor };